import { withInstall } from '@fx-front-framework/utils/with-install'
import FileUpload from './src/file-upload.vue'

export const FxFileUpload = withInstall(FileUpload)
export default FxFileUpload

export * from './src/types'
